import axios from "axios";
import { CUSTOMER_TOKEN_KEY } from "../utils/CustomerAuth";

const customerApi = axios.create({
  baseURL: "https://api.ifjona.com/api",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
});

// Request interceptor
customerApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(CUSTOMER_TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling 401 errors
customerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem(CUSTOMER_TOKEN_KEY);
      window.dispatchEvent(new Event("customer_logged_out"));
      
      // Redirect to login if not already there
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default customerApi;